module.exports = "<section id=photos><ul><li v-for=\"photo in photos\"><img v-bind:src=photo.image /></li></ul><h1 id=top><a data-scroll=data-scroll href=#top>top</a></h1></section>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./public/_src/_vue/Photos.vue
 ** module id = 14
 ** module chunks = 0
 **/